// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PictureOutlinedSvg from "@ant-design/icons-svg/es/asn/PictureOutlined";
import AntdIcon from '../components/AntdIcon';

var PictureOutlined = function PictureOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PictureOutlinedSvg
  }));
};

PictureOutlined.displayName = 'PictureOutlined';
export default React.forwardRef(PictureOutlined);